import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormComponent, RowComponent, FieldComponent } from '@src/app/components';

import { FormType, UIType } from './types';

@Component({
  selector: 'filter-ui-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormComponent,
    RowComponent,
    FieldComponent,
    DropdownModule,
    InputTextModule,
    InputNumberModule,
    InputSwitchModule,
  ],
  templateUrl: './ui-form.component.html',
  styleUrl: './ui-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UIFormComponent {
  @Input() form!: FormGroup<FormType>;
  @Input() loading = false;

  readonly types = [
    UIType.Array,
    UIType.Boolean,
    UIType.Date,
    UIType.Datetime,
    UIType.Number,
    UIType.Object,
    UIType.Text,
    UIType.Time,
  ];
}
